/**
 * Live job activity (`job:activity` over the jobs:<runId> socket topic).
 *
 * Items upsert by `id`; an item carrying `delta` appends to that item's `text`
 * (streamed thinking). This mirrors JobRealtime's merge on the server, so the
 * snapshot a late subscriber receives and the feed built from live events look
 * the same.
 */

const MAX_ITEMS = 400
const TEXT_CAP = 20000

/** Merge one event into a feed. Returns a new array (safe for Vue reactivity). */
export function mergeActivity (items, item) {
  if (!item || !item.id) return items || []
  const list = (items || []).slice()
  const { delta, ...fields } = item
  const index = list.findIndex((entry) => entry.id === item.id)
  const base = index >= 0 ? list[index] : {}
  const next = Object.assign({}, base, fields)
  if (typeof delta === 'string') next.text = ((base.text || '') + delta).slice(-TEXT_CAP)
  if (index >= 0) list.splice(index, 1, next)
  else list.push(next)
  return list.length > MAX_ITEMS ? list.slice(-MAX_ITEMS) : list
}

/** Items directly under `parent` (null = top level), in arrival order. */
export function childrenOf (items, parent) {
  return (items || []).filter((item) => (item.parent || null) === (parent || null))
}

/** Every item tied to one part request (dispatch runs tag them `request: id`). */
export function requestActivity (items, requestId) {
  const id = Number(requestId)
  return (items || []).filter((item) => Number(item.request) === id)
}

/** True while any step in the feed is still going. */
export function activityRunning (items) {
  return (items || []).some((item) => item.kind === 'step' && (item.status === 'running' || item.status === 'waiting'))
}
